import React from 'react';
import PropTypes from 'prop-types';

const Testimonial = props => {
  return (
    <div className="dib pa3">
      <article className="w-100 dib bg-white br3 pa3 pa4-ns ba b--black-10 cf">
        <div className="cf">
          <img src={props.imgPath} alt={props.name} className="fl w-20 br4 ba b--black-20" />

          <blockquote className="fl w-70 pl3 mb3 ma0 ml3 bl bw2 b--black-20 lh-copy f4 black-80 tl">
            &ldquo;{props.children}&rdquo;
          </blockquote>
        </div>

        <span className="tr db f6 i">&mdash; {props.name}</span>
      </article>
    </div>
  );
};

Testimonial.propTypes = {
  imgPath: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default Testimonial;
